import styled from "styled-components";
import { motion } from "framer-motion";

interface GCB_ContainerProps {
	$modulesCount: number;
	$isGroupLessonView: boolean;
}

export const GCB_Container = styled(motion.div)<GCB_ContainerProps>`
	min-height: 0;
	min-width: 0;
	display: grid;

	grid-template-columns: ${({ $modulesCount, $isGroupLessonView }) => {
		if ($isGroupLessonView) {
			return "170px minmax(0, 1fr)";
		}
		const moduleWidth = 220;
		const gap = 10;
		const actualWidth = $modulesCount * moduleWidth + Math.max($modulesCount - 1, 0) * gap;
		const minModules = 3;
		const minWidth = minModules * moduleWidth + (minModules - 1) * gap;
		return `170px max(${minWidth}px, ${actualWidth}px)`;
	}};

	gap: 10px;
	overflow: auto;
	scrollbar-gutter: stable;
`;

export const grandChartBodyVariants = {
	hidden: {},

	visible: {
		transition: {
			delayChildren: 0.12,
			staggerChildren: 0,
		},
	},
	exit: {},
};
